module.exports = __webpack_public_path__ + "img/reset.ce35f11c.svg";